<template>
  <!-- <div>ImagenesTable</div> -->

  <div class="my-3">

    <h6 class="col my-1 text-center">
      <strong>Tabla de Imágenes de la atención</strong>
    </h6>

    <b-row>

      <b-col v-if="imagenesList.length > 0">
        <b-table 
          :items="imagenesList" 
          :fields="tableFields"
          class="text-center"
          responsive small
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template #cell(acciones)="data">
            <b-button
              variant="danger"
              size="sm"
              style="cursor: pointer"
              @click="removeItem(data.item.id)"
            >
              <font-awesome-icon
                icon="circle-xmark"
                style="color: rgb(255, 255, 255)"
              />
            </b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>

  </div>
</template>

<script>
export default {
  name: 'ImagenesTable',

  props: {
    imagenesList:{
      type: Array,
      default:() => []
    },

    onlyView: {
      type: Boolean,
      default: false
    }
  },

  computed: {

    tableFields(){
      const baseFields = [
        { 
          key: "index", 
          label: "N°", 
          thClass: "text-center", 
          tdClass: "text-center" 
        },
        { key: "imagen.nombre", label: "Medicamento", thClass: "text-center" },
        { key: "lateralidad.nombre", label: "Lateralidad",    thClass: "text-center" },
        { key: "numeroOrdenAs400",       label: "# Orden AS400",       thClass: "text-center" },
        { key: "motivoSolicitud",  label: "Motivo Solicitud",  thClass: "text-center" },
        { key: "resumenClinico",    label: "Resumen Clinico",    thClass: "text-center" },
      ];


      if (this.onlyView) return baseFields;

      return [
        ...baseFields, 
        {
          key     : "acciones",
          label   : "acciones",
          sortable: true,
          thClass : "text-center",
          tdClass : "text-right",
        }
      ];
    }
  },

  watch: {
    imagenesList: {
      deep: true,
      handler() {
        console.log('imagenestable', this.imagenesList)
      }
    }
  },

}
</script>
